<!--
 * @Author: your name
 * @Date: 2020-10-15 14:11:15
 * @LastEditTime: 2020-10-29 09:18:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/views/uploadCase/index.vue
-->
<template>
  <div class="work-company-edit">
    <div class="name-title-edit">
      <span class="name-title-tag"></span>
      <span class="name-title-name">{{
        this.editWorkPositionDetail ? '编辑职位' : '添加职位'
      }}</span>
      <Button type="text" @click="cencelCompany" style="margin-left:72%">
        <span style="color: #E56A69">取消</span>
      </Button>
      <Button
        type="primary"
        size="small"
        :loading="submitLading"
        :disabled="submitLading"
        @click="submitHandle"
        >保存</Button
      >
    </div>
    <div class="form">
      <Form
        ref="valivate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="名称" prop="name" style="width:835px">
          <Input
            :maxlength="100"
            show-word-limit
            v-model="formValidate.name"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem label="状态" prop="status">
          <RadioGroup v-model="formValidate.status">
            <Radio label="1">在招</Radio>
            <Radio label="0">暂停招聘</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="薪资" prop="minSalaryProps" style="width:830px">
          <Row>
            <Col span="11">
              <Input
                style="display:inline-block"
                type="number"
                show-word-limit
                :maxlength="10"
                placeholder="请输入"
                v-model="formValidate.minSalary"
              >
                <span
                  style="margin-right: 8px;margin-top: 10px;font-size: 12px;display: inline-block;"
                  slot="suffix"
                  >千元</span
                >
              </Input>
            </Col>
            <Col span="2" style="text-align:center;">
              <span style="display:inline-block">-</span>
            </Col>
            <Col span="11">
              <Input
                style="display:inline-block"
                type="number"
                :maxlength="10"
                v-model="formValidate.maxSalary"
                placeholder="请输入"
                ><span
                  style="margin-right: 8px;margin-top: 10px;font-size: 12px;display: inline-block;"
                  slot="suffix"
                  >千元</span
                ></Input
              >
            </Col>
          </Row>
        </FormItem>

        <FormItem label="工作经验" prop="experience" style="width:830px">
          <Select v-model="formValidate.experience" placeholder="请选择">
            <Option
              :key="index"
              v-for="(item, index) in experienceLists"
              :value="item.id.toString()"
              >{{ item.desc }}</Option
            >
          </Select>
        </FormItem>

        <FormItem label="学历描述" prop="education" style="width:830px">
          <Select v-model="formValidate.education" placeholder="请选择">
            <Option
              :key="index"
              v-for="(item, index) in schooling"
              :value="item.id.toString()"
              >{{ item.desc }}</Option
            >
          </Select>
        </FormItem>

        <FormItem label="职位描述" prop="description" style="width:835px">
          <Input
            :maxlength="100"
            show-word-limit
            type="textarea"
            :rows="4"
            v-model="formValidate.description"
            placeholder="请输入"
          ></Input>
        </FormItem>

        <FormItem label="职位要求" prop="requirements" style="width:835px">
          <Input
            :maxlength="100"
            show-word-limit
            type="textarea"
            :rows="4"
            v-model="formValidate.requirements"
            placeholder="请输入"
          ></Input>
        </FormItem>

        <FormItem label="公司地址" prop="locationIdProps" style="width:835px">
          <Row type="flex" :gutter="10">
            <Col :span="8">
              <Select
                name="province"
                @on-change="changeProvince"
                v-model="provinceId"
                placeholder="请选择省份"
              >
                <Option :value="p.id" :key="p.id" v-for="p in addressData">{{
                  p.name
                }}</Option>
              </Select>
            </Col>
            <Col :span="8">
              <Select
                name="city"
                v-model="cityId"
                @on-change="changeCity"
                placeholder="请选择城市"
              >
                <Option :value="c.id" :key="c.id" v-for="c in cityData">{{
                  c.name
                }}</Option>
              </Select>
            </Col>
            <Col :span="8">
              <Select
                name="zone"
                v-model="formValidate.locationId"
                placeholder="请选择区域"
              >
                <Option :value="z.id" :key="z.id" v-for="z in zoneData">{{
                  z.name
                }}</Option>
              </Select>
            </Col>
          </Row>
        </FormItem>

        <FormItem label="" prop="detailAddress" style="width:835px">
          <Input
            :maxlength="100"
            show-word-limit
            v-model="formValidate.detailAddress"
            placeholder="详细地址"
          ></Input>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
const defaultAddress = {
  locationId: '',
  detailAddress: '',
  userName: '',
  userMobile: '',
  isDefault: 0,
  zipCode: '',
}
import axios from 'axios'
import LayOut from './layout'
export default {
  props: {
    editWorkPositionDetail: {
      type: [Object, String],
      default: null,
    },
  },
  data() {
    return {
      submitLading: false,
      formValidate: {
        name: '',
        status: '1',
        minSalaryProps: '默认',
        minSalary: '',
        maxSalary: '',
        experience: '',
        education: '',
        description: '',
        requirements: '',
        locationIdProps: '默认',
        locationId: '',
        detailAddress: '',
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: '请输入职位名称',
            trigger: 'blur',
          },
        ],
        status: [
          {
            required: true,
            message: '请选择职位状态',
            trigger: 'blur',
          },
        ],
        minSalaryProps: [
          {
            required: true,
            message: '请输入薪资区间',
            trigger: 'blur',
          },
        ],
        minSalary: [
          {
            required: true,
            message: '请输入薪资区间',
            trigger: 'blur',
          },
        ],
        experience: [
          {
            required: true,
            message: '请选择工作经验',
            trigger: 'change',
          },
        ],
        education: [
          {
            required: true,
            message: '请选择学历',
            trigger: 'change',
          },
        ],
        description: [
          {
            required: true,
            message: '请输入职位描述',
            trigger: 'blur',
          },
        ],
        requirements: [
          {
            required: true,
            message: '请输入职位要求',
            trigger: 'blur',
          },
        ],

        locationIdProps: [
          {
            required: true,
            message: '请选择地址',
            trigger: 'change',
          },
        ],
        locationId: [
          {
            required: true,
            message: '请选择地址',
            trigger: 'change',
          },
        ],
        detailAddress: [
          {
            required: true,
            message: '请输入公司详细地址',
            trigger: 'blur',
          },
        ],
      },
      experienceLists: [],
      schooling: [],

      addressData: [],
      cityData: [],
      zoneData: [],
      provinceId: '',
      cityId: '',
      detailAddress: '',
      address: {},
    }
  },
  components: { LayOut },
  methods: {
    // 取消
    cencelCompany() {
      this.$emit('cencelWorkAdd')
    },
    submitHandle() {
      this.$refs['valivate'].validate((valid) => {
        if (valid) {
          this.submitLading = true
          if (!this.formValidate.minSalary) {
            this.$Message.error('请选择输入完整的薪资区间！')
            this.submitLading = false
            return false
          }
          if (!this.formValidate.maxSalary) {
            this.$Message.error('请选择输入完整的薪资区间！')
            this.submitLading = false
            return false
          }
          if (!this.formValidate.locationId) {
            this.$Message.error('请选择公司地址！')
            this.submitLading = false
            return false
          }
          if (!this.editWorkPositionDetail) {
            axios
              .post(
                `/designer_api/job/company/${this.$route.query.id}/position`,
                this.formValidate
              )
              .then((res) => {
                this.$Message.success('添加成功!')
                this.submitLading = false
                this.$emit('editCompanySuccess')
              })
              .catch((err) => {
                this.submitLading = false
              })
          } else {
            axios
              .put(
                `/designer_api/job/company/${this.$route.query.id}/position/${
                  this.editWorkPositionDetail.id
                }`,
                this.formValidate
              )
              .then((res) => {
                this.$Message.success('修改成功!')
                this.submitLading = false
                this.$emit('editCompanySuccess')
              })
              .catch((err) => {
                this.submitLading = false
              })
          }
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields()
    },
    initLocation() {
      if (!this.formValidate.locationId) {
        return
      }
      this.addressData.forEach((province) => {
        province.cities.forEach((city) => {
          city.cities.forEach((zone) => {
            if (zone.id === this.formValidate.locationId) {
              this.provinceId = province.id
              this.cityData = province.cities
              this.cityId = city.id
              this.zoneData = city.cities
            }
          })
        })
      })
    },
    changeProvince(pid) {
      this.addressData.forEach((province) => {
        if (province.id === pid) {
          this.cityData = province.cities
          this.zoneData = []
          this.cityId = ''
          this.formValidate.locationId = ''
        }
      })
    },
    changeCity(cid) {
      this.cityData.forEach((city) => {
        if (city.id === cid) {
          this.zoneData = city.cities
          this.formValidate.locationId = ''
        }
      })
    },

    // 当编辑时候，初始化detail
    setCompanyDetail() {
      if (this.editWorkPositionDetail) {
        Object.assign(this.formValidate, this.editWorkPositionDetail)
        this.$set(
          this.formValidate,
          'experience',
          this.formValidate.experience.toString()
        )
        this.$set(
          this.formValidate,
          'education',
          this.formValidate.education.toString()
        )
        this.$set(
          this.formValidate,
          'status',
          this.formValidate.status.toString()
        )
        this.initLocation()
      }
    },

    // 获得经验列表
    getExperience() {
      axios.get(`/designer_api/job/experience`).then((res) => {
        this.experienceLists = res
      })
    },
    // 获得学历列表
    getEducation() {
      axios.get(`/designer_api/job/education`).then((res) => {
        this.schooling = res
      })
    },
  },
  created() {
    const address_name = 'vuejs__ZHULOGIC_ADDRESS' || 'ZHULOGIC_ADDRESS'
    let lists = JSON.parse(localStorage.getItem(address_name)).value
    if (lists) {
      this.addressData = lists
    } else {
      axios.get('/designer_api/location').then((res) => {
        this.addressData = res
        this.initLocation()
      })
    }
    this.address = { ...defaultAddress }
    this.getExperience()
    this.getEducation()
    this.setCompanyDetail()
  },
}
</script>

<style lang="scss" scoped>
.work-company-edit {
  padding: 40px;
  .name-title-edit {
    margin-bottom: 30px;
    .name-title-tag {
      display: inline-block;
      width: 3px;
      background: #e56a69;
      margin-right: 8px;
      vertical-align: middle;
      height: 14px;
      margin-top: -5px;
    }
    .name-title-name {
      font-size: 16px;
      font-weight: bold;
      color: #373737;
    }
  }
  .title {
    margin-top: 60px;
    font-size: 24px;
    font-weight: 500;
    color: #1a1816;
  }
  .form {
    margin-top: 40px;
  }
  /deep/ .ivu-select-selection {
    background-color: #f0f2f5;
    border: none;
  }
  /deep/ .ivu-input {
    background-color: #f0f2f5;
    border: none;
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    color: #999;
  }
  /deep/ .slot-con {
    background: #fff;
    width: 150px;
  }
  .upload-view-title {
    font-size: 14px;
    font-weight: 500;
    color: #373737;
    margin-bottom: 5px;
    > span {
      color: red;
    }
  }
  .uoload-view {
    width: 100px;
    height: 100px;
    border-radius: 2px;
    border: 1px dotted #bfbfbf;
    text-align: center;
    border-radius: 3px;
    overflow: hidden;
    span.uoload-view-span {
      display: inline-block;
      width: 76px;
      height: 30px;
      background: #f0f2f5;
      border-radius: 2px;
      font-size: 12px;
      font-weight: 400;
      color: #373737;
      line-height: 30px;
      margin-top: 35px;
    }
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .upload-desc {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    margin-top: 15px;

    i.icon-jinggao {
      color: #e66a69;
      vertical-align: middle;
    }
  }
  /deep/ .ivu-table th,
  .ivu-table td {
    border-bottom: 1px solid #e8eaec;
  }

  .uoload-view-tabel {
    width: 110px;
    height: 110px;
    border-radius: 2px;
    > span {
      margin-top: 40px;
    }
  }

  .addTabel {
    background: #fafafa;
    border: 1px dotted #d4d4d4;
    width: 100%;
    height: 45px;
    margin-top: 5px;
    &:hover {
      opacity: 0.8;
    }
    cursor: pointer;
    text-align: center;
    line-height: 45px;
    border-radius: 3px;
    > i {
      vertical-align: middle;
    }
  }
  .main-sublit {
    margin-top: 100px;
    text-align: center;
  }

  .upload-desc {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    margin-top: 0px;
    margin-top: -15px;
    margin-left: 78px;
    float: left;
  }

  /deep/ .ivu-progress {
    top: 100%;
    left: -17px;
  }

  /deep/ .ivu-radio-group {
    margin-top: 2px;
    .ivu-radio-inner:after {
      background-color: #e56a69;
    }
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #e56a69;
    }
  }
}
</style>
